import { render, staticRenderFns } from "./SocialUploadTable.vue?vue&type=template&id=64a7e20b&scoped=true"
import script from "./SocialUploadTable.vue?vue&type=script&lang=js"
export * from "./SocialUploadTable.vue?vue&type=script&lang=js"
import style0 from "./SocialUploadTable.vue?vue&type=style&index=0&id=64a7e20b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7e20b",
  null
  
)

export default component.exports